var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  COVER: null,
  STAMPS: null,
  ZINES: null,
  FEED: null,
  SOCIAL_PROOF: null
});


/** WEBPACK FOOTER **
 ** ./constants/AboutSectionTypes.js
 **/